<!-- NO LONGER USED ORIGINAL ELVENARCHITECT INTEGRATION -->
<template>
    <div>
        <br/>
        <br/>
        <img src="../assets/elvenArchitectLogo.png" width="392">


        <H3>Instructions To Load {{player.username}}'s city into ElvenArchitect</h3>
        <ol>
            <li> Click the COPY button below -or - highlight the entire very long string below to your clipboard</li>
            <li> Open <a target="_blank" href="http://www.elvenarchitect.com/city/planner/">http://www.elvenarchitect.com/city/planner/</a></li>
            <li> Select <strong>{{player.race}}</strong> as the race </li>
            <li> On the bottom there is a load button, click that. </li>
            <li> Then select the File tab, clear out the text, and then PASTE.</li>
            <li> Click load.</li>
        </ol>

        <button type="button" class="btn btn-primary btn-lg"
                v-clipboard:copy="base64Map"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"><i class="fas fa-clipboard">&nbsp;</i>Copy To Clipboard</button>

        <div>
            City Snapshot saved on: {{cityMap.updatedAt}} (<relative-time-formatter :time="cityMap.updatedAt"/>)
        </div>
        <v-container fluid>
            <v-layout row>
                <v-flex xl12>
                    <v-text-field
                            name="input-1"
                            v-model="base64Map"
                            label="ElvenArchitect File Import payload."
                            textarea
                            read-only
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </v-container>


        <div class="row">
            <h4>Step 4 Screenshot</h4>
            <img src="../assets/elvenArchitectStep1.png">
        </div>

        <div class="row">
            <h4>Step 5 Screenshot</h4>
            <img src="../assets/elvenArchitectStep2.png">
        </div>

    </div>

</template>

<script>
    import Vue from 'vue';
    import VueHighcharts from 'vue-highcharts';
    import Highcharts from 'highcharts';
    import _ from 'lodash';
    import ElvBoostIcon from '@/components/ElvBoostIcon';
    import VueNumeric from 'vue-numeric';
    let elvenStats = require('../lib/elven-stats');
    import axios from 'axios';
    import moment from 'moment';
    // import clipboard from 'clipboard';
    import VueClipboard2 from 'vue-clipboard2';
    import RelativeTimeFormatter from "../components/RelativeTimeFormatter"
    import ElvArchitectRedirector from "../components/ElvArchitectRedirector"
    Vue.use(VueClipboard2)

    export default {
        name: "player-elven-architect",
        components: {
            ElvArchitectRedirector,
            RelativeTimeFormatter,
            ElvBoostIcon, VueNumeric, VueClipboard2},
        props: ['playerId', 'server'],
        data() {
            return {
                player: { },
                cityMap: {},
                base64Map: "",
            }
        },
        mounted() {
            var self = this;
            axios.get(`/api/player/${self.server}/${self.playerId}/citymap/`).then( (response) => {
                axios.get(`/api/player/${self.server}/${self.playerId}`).then( (response2) => {
                    self.player = response2.data;
                    self.cityMap = response.data;

                    var payload = {
                        "city_map": {
                            "unlocked_areas": self.cityMap.body.city_map.unlocked_areas,
                            "entities": self.cityMap.body.city_map.entities,
                        },
                        "user_data": {
                            "race": self.cityMap.body.other_player.race
                        }
                    };

                    self.base64Map = btoa(JSON.stringify(payload));
                })
            });
        },
        methods: {
            onCopy: function (e) {
                alert('Copy To Clipboard Successful!');
            },
            onError: function (e) {
                alert('Failed to copy highlight the entire text area and then do CTRL+C')
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/PlayerElvenArchitect.vue